<template>
  <div>
    <Table
      @on-sort-change="changesort"
      stripe
      :columns="columns"
      :data="data"
    ></Table>
    <div class="page-div">
      <Page
        :total="obj.total"
        @on-page-size-change="changepeoplepage"
        @on-change="changePeoplecurrent"
        show-elevator
        show-total
        :current="current"
        :page-size="pageSize"
        show-sizer
        class="page-div-page"
      />
    </div>
    <div style="clear:both;"></div>
    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
  </div>
</template>
<script>
    import {
        formatMoney,
        selectOrderListByStatementId
    } from "../servers/api";
    export default {
        data() {
            return {
                isiconfontshow: false,
                selectNum: 0,
                pageSize: 20,
                current: 1,
                columns: [{
                    type: "selection",
                    width: 60,
                    align: "center"
                }, {
                    title: "订单号",
                    key: "orderNum",
                    ellipsis: true,
                    sortable: true,
                    align: "center"
                }, {
                    title: "订单金额",
                    key: "unitPrice",
                    ellipsis: true,
                    sortable: true,
                    align: "center",
                    render: (h, params) => {
                        let a = "￥" + formatMoney(params.row.unitPrice);
                        return h("div", [
                            h(
                                "span", {
                                    style: {
                                        display: "inline-block",
                                        width: "100%",
                                        height: "30px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        "line-height": "37px",
                                        color: "#7F7F7F"
                                    }
                                },
                                a
                            )
                        ]);
                    }
                }, {
                    title: "姓名",
                    width: 120,
                    key: "patientName",
                    ellipsis: true,
                    sortable: true,
                    align: "center"
                }, {
                    title: "性别",
                    width: 100,
                    key: "sex",
                    ellipsis: true,
                    sortable: true,
                    align: "center"
                }, {
                    title: "年龄",
                    width: 100,
                    key: "age",
                    ellipsis: true,
                    sortable: true,
                    align: "center"
                }],
                data: [{}],
                statementId: "",
                orderField: "",
                isAsc: "",
                obj: {}
            };
        },
        methods: {
            postselect(item) {
                //父组件传来的参数
                this.statementId = item.statementId;
                this.selectOrderListByStatementId(1);
            },
            selectOrderListByStatementId(index) {
                this.isiconfontshow = true;
                if (index) {
                    this.current = 1;
                }
                let params = {
                    pageNum: this.current,
                    pageSize: this.pageSize,
                    statementId: this.statementId,
                    orderField: this.orderField,
                    isAsc: this.isAsc
                };
                selectOrderListByStatementId(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.obj = res.data.data || {};
                        this.data = res.data.data.list || [];
                    }
                });
            },
            changePeoplecurrent(num) {
                //换页
                this.current = num;
                this.selectOrderListByStatementId();
            },
            changepeoplepage(num) {
                //切换条数
                this.pageSize = num;
                this.selectOrderListByStatementId(1);
            },
            changesort(item) {
                //排序
                this.orderField = item.key;
                this.isAsc = item.order;
                this.current = 1;
                if (item.order == "normal") {
                    this.isAsc = "";
                    this.orderField = "";
                }
                this.selectOrderListByStatementId(1);
            }
        }
    };
</script>
<style lang="scss" scoped="" type="text/css">
    @import "../css/conmmon.scss";
    @import "../font/iconfont.css";
    .page-div {
        width: 100%;
        margin-top: 15px;
        .page-div-left {
            float: left;
            padding: 5px 10px;
        }
        .page-div-lefts {
            border-right: 1px solid #d7d7d7;
            margin-right: 15px;
        }
        .page-div-page {
            float: right;
            margin-right: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/tan/tisee.vue